/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Stage_PipelineInputs */

const en_svc_stage_pipeline = /** @type {(inputs: Svc_Stage_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent & Pipeline Mesh`)
};

const ar_svc_stage_pipeline = /** @type {(inputs: Svc_Stage_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شبكة الوكلاء وخطوط البيانات`)
};

const bn_svc_stage_pipeline = /** @type {(inputs: Svc_Stage_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এজেন্ট ও পাইপলাইন মেশ`)
};

const de_svc_stage_pipeline = /** @type {(inputs: Svc_Stage_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent und Pipeline-Netz`)
};

const es_svc_stage_pipeline = /** @type {(inputs: Svc_Stage_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agente y malla de canalización`)
};

const fr_svc_stage_pipeline = /** @type {(inputs: Svc_Stage_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent et maillage de pipeline`)
};

const pt_svc_stage_pipeline = /** @type {(inputs: Svc_Stage_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agente e malha de pipeline`)
};

const zh_svc_stage_pipeline = /** @type {(inputs: Svc_Stage_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理和管道网格`)
};

const tr_svc_stage_pipeline = /** @type {(inputs: Svc_Stage_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aracı ve Boru Hattı Ağı`)
};

const ru_svc_stage_pipeline = /** @type {(inputs: Svc_Stage_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сетка агента и конвейера`)
};

const pl_svc_stage_pipeline = /** @type {(inputs: Svc_Stage_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent i siatka rurociągów`)
};

/**
* | output |
* | --- |
* | "Agent & Pipeline Mesh" |
*
* @param {Svc_Stage_PipelineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_stage_pipeline = /** @type {((inputs?: Svc_Stage_PipelineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Stage_PipelineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_stage_pipeline(inputs)
	if (locale === "bn") return bn_svc_stage_pipeline(inputs)
	if (locale === "de") return de_svc_stage_pipeline(inputs)
	if (locale === "es") return es_svc_stage_pipeline(inputs)
	if (locale === "fr") return fr_svc_stage_pipeline(inputs)
	if (locale === "pt") return pt_svc_stage_pipeline(inputs)
	if (locale === "zh") return zh_svc_stage_pipeline(inputs)
	if (locale === "tr") return tr_svc_stage_pipeline(inputs)
	if (locale === "ru") return ru_svc_stage_pipeline(inputs)
	if (locale === "pl") return pl_svc_stage_pipeline(inputs)
	return en_svc_stage_pipeline(inputs)
});